
import React from 'react';
import { Loader2 } from 'lucide-react';

export const PageLoading: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white/80">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-10 w-10 text-brand-blue-500 animate-spin" />
        <p className="text-brand-gray-600 font-medium animate-pulse">Cargando...</p>
      </div>
    </div>
  );
};
